export const selectSelectedCategoriesHabitual = s => s.purchase.selectedCategoriesHabitual
export const selectPurchaseProducts = s => s.purchase.products
export const selectAddProductsQueue = s => s.purchase.addProductsQueue
